<div class="user-dashboard">
    <wr-user-dashboard-inspection-overview></wr-user-dashboard-inspection-overview>
  <wr-user-dashboard-building-overview></wr-user-dashboard-building-overview>
  @if (repairTasksVisible()) {
    <wr-user-dashboard-repair-task-overview></wr-user-dashboard-repair-task-overview>
  }
</div>
